import * as React from "react";
import i18n from "i18n";
import { Grid, Button, Typography, Paper } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { ProfileStore } from "modules/profile/ProfileStore";
import { LoginService } from "modules/login/LoginService";
import { LoginStore } from "modules/login/LoginStore";
import { insertTagsAtText } from "utils/StringUtils";

const styles = (theme) => ({
  base: {
    width: "100vw",
    height: "100vh",
    position: "absolute" as any,
    top: "0px",
    left: "0px",
    backgroundColor: "RGBA(0,0,0,.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 99,
  },
  paper: {
    height: "257px",
    width: "562px",
    padding: "24px 15px",
  },
  titleTrial: {
    color: "#9AAF00",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "24px",
    lineHeight: "28px",
    textTransform: "uppercase" as any,
    textAlign: "center" as any,
  },
  textTrial: {
    color: "#757575",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "19px",
    textAlign: "center" as any,
    margin: "40px 0px",
    padding: "0px 65px",
  },
  btnSing: {
    border: "none",
    backgroundColor: "#9AAF00",
    color: "#FFFFFF",
  },
});

async function sendLeadHubspot() {
  const email = LoginStore.userAuth!.email || "";
  await LoginService.sendClickEventToHubspot(email);
  return;
}

const TrialExpired = (props) => {
  const { classes } = props;

  return (
    <div className={classes.base}>
      <Paper className={classes.paper}>
        <Typography variant="h4" gutterBottom className={classes.titleTrial}>
          {i18n.trialExpired.title}
        </Typography>
        <Typography variant="body2" className={classes.textTrial}>
          {insertTagsAtText(i18n.trialExpired.message)}
        </Typography>
        <Grid container direction="row" justify="center">
          <Button
            className={classes.btnSing}
            onClick={async () => {
              await sendLeadHubspot();
              window.open("https://www.rubk.com.br/assine-agora/");
            }}
            target="_blank"
          >
            {i18n.trialRegister.subscribeNow}
          </Button>
        </Grid>
      </Paper>
    </div>
  );
};

export default withStyles(styles)(TrialExpired);



// WEBPACK FOOTER //
// ./src/modules/development/components/layouts/TrialExpired.tsx